import Component from 'gia/Component';
import Cookies from 'js-cookie'


export default class Header extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      form: {},
      thankyou: {},
      errormessage: {},
      close:{}
    };
  }

  mount() {
    let that = this;


    this.ref.close.addEventListener('click', function() {
      Cookies.set('newsletter', 'ok', { expires: 30 });
      that.element.classList.add('hidden');
    });

    // const form = document.getElementById('mailchimp')
    this.ref.form.onsubmit = (e) => {
      e.preventDefault();
      that.ref.form.classList.add('hidden');
      that.ref.errormessage.classList.add('hidden');
      fetch('/mailchimp/send', {
        method: 'post',
        body: new FormData(e.target)
      })
        .then((r) => r.json())
        .then((r) => {
          if (r.success) {
            // alert(r.msg)
            that.ref.thankyou.classList.remove('hidden');
            Cookies.set('newsletter', 'ok', { expires: 30 });
            setTimeout(() => {
              that.element.classList.add('hidden');
            },3000)
          } else {
            // alert(r.msg)
            that.ref.form.classList.remove('hidden');
            that.ref.errormessage.classList.remove('hidden');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

  }
}